/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MasterGetAdminUserDataDto
 */
export interface MasterGetAdminUserDataDto {
    /**
     * 어드민 유저 uuid
     * @type {string}
     * @memberof MasterGetAdminUserDataDto
     */
    'adminUserUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof MasterGetAdminUserDataDto
     */
    'id': string;
    /**
     * 이름
     * @type {string}
     * @memberof MasterGetAdminUserDataDto
     */
    'name': string;
    /**
     * 로그인 제한 여부
     * @type {boolean}
     * @memberof MasterGetAdminUserDataDto
     */
    'isLoginRestrict': boolean;
    /**
     * 생성 일시
     * @type {string}
     * @memberof MasterGetAdminUserDataDto
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterGetAdminUserDataDto
     */
    'permissions': Array<MasterGetAdminUserDataDtoPermissionsEnum>;
}

export const MasterGetAdminUserDataDtoPermissionsEnum = {
    Dashboard: 'dashboard',
    Report: 'report',
    AccountManagement: 'accountManagement',
    UserManagement: 'userManagement',
    ExchangeManagement: 'exchangeManagement',
    OperationManagement: 'operationManagement'
} as const;

export type MasterGetAdminUserDataDtoPermissionsEnum = typeof MasterGetAdminUserDataDtoPermissionsEnum[keyof typeof MasterGetAdminUserDataDtoPermissionsEnum];


